export default [
  {
    path: '/admin/reports',
    name: 'Reports',
    component: () => import('@/views/Admin/Reports/Index.vue'),
    meta: {
      pageTitle: 'Raporlar',
      breadcrumb: [{ text: 'Raporlar', active: true }],
      resource: 'reports.list',
      action: 'read',
    },
  },
]
